<template>
    <img :src="signature" alt="" v-if="readonly">
    <div v-else>
        <SignaturePad :modelValue="signature" :width="500" :height="300" ref="signaturePad" @input="onInput" />
        <input type="hidden" name="signature" v-model="data">
        <button type="button" class="btn btn-sm btn-outline-warning" @click="clear" :disabled="! data" v-if="! readonly">
            {{ $trans.get('__JSON__.Erase') }}
        </button>
    </div>
</template>

<script>
import SignaturePad from 'vue3-signature-pad'

export default {
    components: { SignaturePad },
    props: {
        signature: {
            type: String,
            required: false,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            data: null,
        }
    },
    methods: {
        onInput(signature) {
            this.data = signature
        },
        clear() {
            this.$refs.signaturePad.clearSignature()
        },
    },
}
</script>
